// https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
import styled from 'styled-components';

export const offScreenify = component =>
  styled(component)`
    display: block;
    clip: rect(1px 1px 1px 1px); /* IE 6/7 */
    clip: rect(1px, 1px, 1px, 1px);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap; /* added line */
    width: 1px;
  `;

export const OffScreenDiv = offScreenify('div');
export const OffScreenSpan = offScreenify('span');



// WEBPACK FOOTER //
// ./src/components/primitives/AccessibilityText.js